// extracted by mini-css-extract-plugin
export default {"operateUltrasonicInstall":"operateModal_operateUltrasonicInstall__NMP33","formBox":"operateModal_formBox__j6GB0","imageBox":"operateModal_imageBox__DKNo4"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"operateUltrasonicInstall\":\"operateModal_operateUltrasonicInstall__NMP33\",\"formBox\":\"operateModal_formBox__j6GB0\",\"imageBox\":\"operateModal_imageBox__DKNo4\"}";
        // 1793760841465
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  